var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCircleDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20H25.5C24.1739 20 22.9021 20.5268 21.9645 21.4645C21.0268 22.4021 20.5 23.6739 20.5 25C20.5 26.3261 21.0268 27.5979 21.9645 28.5355C22.9021 29.4732 24.1739 30 25.5 30H35.5C36.8261 30 38.0979 30.5268 39.0355 31.4645C39.9732 32.4021 40.5 33.6739 40.5 35C40.5 36.3261 39.9732 37.5979 39.0355 38.5355C38.0979 39.4732 36.8261 40 35.5 40H20.5M30.5 45V15M55.5 30C55.5 43.8071 44.3071 55 30.5 55C16.6929 55 5.5 43.8071 5.5 30C5.5 16.1929 16.6929 5 30.5 5C44.3071 5 55.5 16.1929 55.5 30Z",
    stroke: "#4B286D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCircleDollarSign);
export default __webpack_public_path__ + "static/media/big-circle-dollar-sign.e411834621499235613499b1efe6e76a.svg";
export { ForwardRef as ReactComponent };